import { IntegrationDropdownOption } from "../../../hooks/useLoadIntegrationsDropdownOptions";

export const formatMockSandboxAccountToken = (
  integration?: IntegrationDropdownOption,
): string | undefined => {
  if (!integration) return;
  return `${integration.slug.toUpperCase()}_SANDBOX`;
};
